import { Component } from '@angular/core';
import { ToastAlertColor, ToastAlertType } from './toast-alert.types';

@Component({
  selector: 'fl-toast-alert-global',
  template: `
    <fl-toast-alert
      i18n="File Viewer loading toast alert"
      [id]="'file-viewer-loading'"
      [timeout]="undefined"
      [closeable]="true"
      [type]="ToastAlertType.LOADING"
    >
      Loading preview
    </fl-toast-alert>
  `,
})
export class ToastAlertGlobalComponent {
  ToastAlertType = ToastAlertType;
  ToastAlertColor = ToastAlertColor;
}
